module.exports = __webpack_public_path__ + "static/media/image-13.6450ff5c.png";